import { Component, OnInit } from '@angular/core';
import { ContentfulService } from '@shared/services/contentful.service';
import { Entry } from 'contentful';

@Component({
  selector: 'rav-social-media-links',
  templateUrl: './social-media-links.component.html',
  styleUrls: ['./social-media-links.component.scss']
})
export class SocialMediaLinksComponent implements OnInit {
  socialMediaItems: Entry<any>[] = [];

  constructor(private contentful: ContentfulService) {}

  ngOnInit() {
    this.contentful.getSocialMediaLinks().then((socialMediaItems) => (this.socialMediaItems = socialMediaItems));
  }
}
